import styled from "styled-components";

export const H2 = styled.h2`
    color: var(--white-color);
    font-size: 36px;
    width: 100%;
    text-align: center;
    margin-top: 50px;
    margin-bottom: 30px;

    @media (max-width: 1024px) {
        margin-top: 0;
    }
`
export const Div = styled.div`
    width: 50%;
    position: relative;
    right: -100px;
    display: flex;
    flex-direction: column;
    align-items: center;

    img{
        border-left: 1px solid var(--white-color);
        width: 100%;
        margin-top: 20px;
    }

    @media (max-width: 1024px){
        width: 90%;
        right: 0;
    }
`
export const P = styled.p`
    width: 100%;
    text-align: center;
    right: -100px;
`
export const H3 = styled.h3`
    color: var(--white-color);
    font-size: 28px;
    width: 100%;
    text-align: center;
    margin-top: 50px;
    margin-bottom: 10px;
`

export const Ul = styled.ul`
    width: 50% ;
    list-style: circle;
`